import { gql } from "@grandvisionhq/graphql";
const insurance = gql`
  fragment InsuranceFragment on Insurance {
    sku
    id
    quantity
    name {
      value
    }
    price {
      total {
        gross
        net
        subtotal
      }
      unit {
        gross
        net
        subtotal
      }
    }
  }
`;
export {
  insurance
};
//# sourceMappingURL=insurance.js.map
